import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import store from "../helpers/store";
import { formattedChosenAvailability } from '../helpers/date'
import { getUTMParamsFromURL } from '../helpers/utm';

const sendAnalyticsEvents = (props) => {
  if (props.formattedAppointment.year === "") {
    return;
  }

  // Base analytics attributes
  let analyticsAttributes = {
    event_owner: "ShopLoader",
    form_name: "ShopLoader Service Scheduler",
    element_text: "Submit Appointment",
    item_year: props.formattedAppointment.year,
    item_make: props.formattedAppointment.make,
    item_model: props.formattedAppointment.model
  };

  // Add debug mode if not in production
  if (window.gon.environment !== "production") {
    analyticsAttributes.debug_mode = true;
  }

  // Get UTM parameters and merge with analytics attributes
  const utmData = getUTMParamsFromURL();
  analyticsAttributes = { ...analyticsAttributes, ...utmData };

  // Send analytics events with the populated attributes
  gtag('event', 'asc_form_submission', analyticsAttributes);
  gtag('event', 'asc_form_submission_service_appt', analyticsAttributes);
};

const ReviewScreen = (props) => {
  useEffect(() => {
    props.fetchAdvisors();
    props.fetchOrganization();
    sendAnalyticsEvents(props);
  }, []);

  const displayAdvisorSelection =
    !window.gon.shoploader_lite ||
    (window.gon.shoploader_lite &&
      props.advisors &&
      Object.keys(props.advisors).length > 1);

  return (
    <Container id="review-appointment" fluid>
      <Row>
        <Col>
          <Card>
            <Card.Header>Your Appointment Request</Card.Header>
            <Card.Body>
              Name: <b>{props.formattedAppointment.name}</b>
              <br />
              Mobile Phone: <b>{props.formattedAppointment.phoneNumber}</b>
              <br />
              Email: <b>{props.formattedAppointment.email}</b>
              <br />
              {(props.formattedAppointment.mobileServiceLocation && (
                <>Vehicle Location: <b>{props.formattedAppointment.mobileServiceLocation}</b><br /></>)
              )}
              {(props.formattedAppointment.specialInstructions && (
                <>Special Instructions: <b>{props.formattedAppointment.specialInstructions}</b><br /></>)
              )}
              Vehicle:{" "}
              <b>
                {`${props.formattedAppointment.year} ${props.formattedAppointment.make} ${props.formattedAppointment.model}`}
              </b>
              <br />
              {(props.formattedAppointment.vin && (
                <>VIN: <b>{props.formattedAppointment.vin}</b><br /></>)
              )}
              {(props.formattedAppointment.mileage && (
                <>Mileage: <b>{props.formattedAppointment.mileage}</b><br /></>)
              )}
              Concern Description:
              <b>
                {` ${props.formattedAppointment.concern}`}
                {props.formattedAppointment.concernDetail
                  ? ` (${props.formattedAppointment.concernDetail})`
                  : ""}
              </b>
              {props.formattedAppointment.concernDescriptionAdditionalDetails && (<>
                <br />
                Concern Detail:&nbsp;
                <b>{props.formattedAppointment.concernDescriptionAdditionalDetails}</b>
              </>)}
              {props.formattedAppointment.additionalConcerns && (<>
                <br />
                Additional Concerns:&nbsp;
                <b>{props.formattedAppointment.additionalConcerns}</b>
              </>)}
              <br />
              {displayAdvisorSelection && (<>
                Advisor: <b>{props.formattedAppointment.advisor}</b>
                <br />
              </>)}
              Appointment Time:{" "}
              <b>{formattedChosenAvailability(props.formattedAppointment.concernAttributes, props.formattedAppointment.date)}</b>
              <br />
              {props.formattedAppointment.rentalRequested && (
                <>
                  &#x2713; {props.organization.rental_requested_label}
                  <br />
                </>
              )}
              {props.formattedAppointment.shuttleRequested && (
                <>
                  &#x2713; {props.organization.shuttle_requested_label}
                  <br />
                </>
              )}
              {props.formattedAppointment.pickupRequested && (
                <>
                  &#x2713; {props.organization.pickup_requested_label}
                  <br />
                </>
              )}
              {props.formattedAppointment.waiter && (
                <>
                  &#x2713; {props.organization.waiter_label}
                  <br />
                </>
              )}
              {props.formattedAppointment.selfDropRequested && (
                <>
                  &#x2713; {props.organization.self_drop_label}
                  <br />
                </>
              )}
              {props.formattedAppointment.nightDropRequested && (
                <>
                  &#x2713; {props.organization.night_drop_label}
                  <br />
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {props.appointment.submitted ? (
        <Row>
          {props.appointment.ok ? (
            <Col>
              <Alert variant="success">
                Your appointment request was submitted successfully.
              </Alert>
              {props.organization.homepage_url && (
                <Link
                  to={{ pathname: props.organization.homepage_url }}
                  target="_parent"
                  className="btn btn-dark"
                >
                  Return to Homepage
                </Link>
              )}
            </Col>
          ) : (
            <Col>
              <Alert variant="danger">
                <p>There was an error submitting your appointment request.</p>
                <p>{props.appointment.errorText}</p>
                <p>Please call us{props.organization.phone_number && (<span> at {props.organization.phone_number}</span>)} if this error continues.</p>
              </Alert>
              <Link
                to={{ pathname: props.organization.schedule_service_url }}
                target="_parent"
                className="btn btn-dark"
              >
                Back
              </Link>
            </Col>
          )}
        </Row>
      ) : (
        <Row>
          <Col>
            <Link
              to={{ pathname: props.organization.schedule_service_url }}
              target="_parent"
              className="btn btn-dark"
            >
              Back
            </Link>
          </Col>
        </Row>
      )}
    </Container>
  );
};

const mapState = (state) => ({
  appointment: state.appointment,
  organization: state.organization,
  advisors: state.advisors,
  formattedAppointment: store.select.appointment.formatted(state),
});

const mapDispatch = (dispatch) => ({
  fetchOrganization: dispatch.organization.fetchAsync,
  fetchAdvisors: dispatch.advisors.fetchAsync
});

export default connect(mapState, mapDispatch)(ReviewScreen);
